import http from '../../../lib/http';

export const FETCH_BAR_REPORT_CASHBOXES_START = 'FETCH_BAR_REPORT_CASHBOXES_START';
export const FETCH_BAR_REPORT_CASHBOXES_ERROR = 'FETCH_BAR_REPORT_CASHBOXES_ERROR';
export const FETCH_BAR_REPORT_CASHBOXES_SUCCESS = 'FETCH_BAR_REPORT_CASHBOXES_SUCCESS';

export const POST_BAR_REPORT_CASHBOX_VALUE_START = 'POST_BAR_REPORT_CASHBOX_VALUE_START';
export const POST_BAR_REPORT_CASHBOX_VALUE_ERROR = 'POST_BAR_REPORT_CASHBOX_VALUE_ERROR';
export const POST_BAR_REPORT_CASHBOX_VALUE_SUCCESS = 'POST_BAR_REPORT_CASHBOX_VALUE_SUCCESS';

export const CLEAN_BAR_REPORT_CASHBOXES = 'CLEAN_BAR_REPORT_CASHBOXES';
export const SHOW_REPORT_CASHBOXES_COUNTER = 'SHOW_REPORT_CASHBOXES_COUNTER';

export function openReportCashboxesCounter(show, closeReport = false) {
    return {
        type: SHOW_REPORT_CASHBOXES_COUNTER,
        payload: {show, closeReport}
    };
}

export function cleanBarReportCashboxes() {
    return {
        type: CLEAN_BAR_REPORT_CASHBOXES
    };
}

export function setBarReportCashboxValue(id, type, value, coins) {
    return {
        type: 'POST_BAR_REPORT_CASHBOX_VALUE',
        payload: {
            promise: postBarReportCashboxValue(id, type, value, coins)
        }
    };
}

async function postBarReportCashboxValue(id, type, value, coins) {
    const res = await http.post(`/app/report/save/cashbox/${id}/${type}`, {
        body: {
            amount: value,
            coins: JSON.stringify(coins)
        }});
    if (res.status < 300) return res.json();
    throw res;
}

export function fetchBarReportCashboxes(barId) {
    return {
        type: 'FETCH_BAR_REPORT_CASHBOXES',
        payload: {
            promise: getBarReportCashboxes(barId)
        }
    };
}

async function getBarReportCashboxes(barId) {
    const res = await http.get(`/app/report/bar-report-cashboxes/${barId}`);
    if (res.status < 300) return res.json();
    throw res;
}



// WEBPACK FOOTER //
// ./src/common/menu/report/cashboxes/actions.js